export default {
  guidanceConfig: null
}
